define('lib/leaflet-wms-get-feature-info/response-formatter',[],function() {
  function formatJson(json) {
    var output = '';
    var contentParsed = JSON.parse(json);
    if (contentParsed.features && contentParsed.features.length) {
      output += '<table class="lwfi__popup-table">';
      contentParsed.features.forEach(function(feature) {
        output += '<tr><td>Lager</td><td>' + feature.id + '</td></tr>';
        Object.keys(feature.properties).forEach(function(property) {
          output +=
            '<tr><td>' + property + '</td><td>' + feature.properties[property] + '</td></tr>';
        });
      });
      output += '</table>';
    }

    return output;
  }

  function formatPlainText(text) {
    return text.replace('\n', '<br>');
  }

  function formatXml(xml) {
    return xml; //todo: implement
  }

  function formatHtml(html) {
    var htmlElement = document.createElement('html');
    htmlElement.innerHTML = html;
    var contentTable = htmlElement.querySelector('table');
    if (!contentTable) return '';

    contentTable.classList.add('lwfi__popup-table');
    return contentTable.outerHTML;
  }

  return {
    formatJson: formatJson,
    formatPlainText: formatPlainText,
    formatXml: formatXml,
    formatHtml: formatHtml,
  };
});

